<div class="add-row-modal body" (keydown.enter)="_addRow()">
    <div class="input" (keydown)="_onKeydownCode($event)">
        <input-field #codeField class="code-input" [value]="_code"
            (valueChange)="_onCodeChange($event)" title="Code"></input-field>
        <input-field class="description-input" [value]="_description" (valueChange)="_onDescriptionChange($event)"
            title="Hoofdstuk"></input-field>
    </div>
    <div class="category-box-container">
        <div class="gradient-border">
            <div class="box">
                <div class="category-container" *ngFor="let cat of _filteredTemplate">
                    <div class="category">
                        <input type="checkbox" (change)="_onCategorySelect(cat)" [checked]="_selectedCategories | includes:cat"
                            class="regular-checkbox" />
                        <!-- <div class="category" (click)="onClickCategory(cat)" > -->
                        <div class="opener" (click)="_onClickOpenCategory(cat, $event)"><i class="fas"
                                [class.fa-caret-right]="cat.open | not" [class.fa-caret-down]="cat.open"></i></div>
                        <div class="code" (click)="_onClickOpenCategory(cat, $event)">{{ cat.code }} </div>
                        <div class="description" (click)="_onClickOpenCategory(cat, $event)">{{ cat.name }}</div>
                    </div>
                    <ng-container *ngIf="cat.open">
                        <div class="sub-category" *ngFor="let sub of cat.subcategories" (click)="_onSubcategorySelect(cat, sub)">
                            <!-- <div class="sub-category" (click)="onClickSubCategory(sub)" *ngFor="let sub of cat.subs"> -->
                            <input type="checkbox" [checked]="_selectedSubcategories | includes:sub" class="regular-checkbox" />
                            <div class="code">{{ sub.code }} </div>
                            <div class="description">{{ sub.name }}</div>
                        </div>
                    </ng-container>
                </div>
            </div>
        </div>
    </div>
    <div class="footer">
        <div class="check">
            <label>Standaard regels</label>
            <input type="checkbox" [(ngModel)]="_useStandardLines">
        </div>

        <div class="button-thin" [class.active]="_canAdd" (click)="_addRow()">Toevoegen</div>
    </div>
</div>